import React from 'react';
import ReactMarkdown from 'react-markdown';

import BgSprinkles from './BgSprinkles';
import NewHeader from './NewHeader';
import '../styles/components/EmptyPage.scss';

export default function EmptyPage({ text }) {
	return (
		<>
			<NewHeader />
			<div className='empty-page-wrapper'>
				<BgSprinkles amount={10} />
				<div className='container'>
					<div className='content'>
						<ReactMarkdown>{text}</ReactMarkdown>
					</div>
				</div>
			</div>
		</>
	);
}
